import { Controller } from "@hotwired/stimulus"

// Stimulus controller do zarządzania dynamicznymi nested forms (np. external_ids)
// Użycie:
// <div data-controller="nested-form">
//   <template data-nested-form-target="template">...</template>
//   <div data-nested-form-target="container"></div>
//   <button data-action="click->nested-form#addField">Dodaj</button>
// </div>
export default class extends Controller {
  static targets = ["template", "container", "fields"]

  connect() {
    console.log("NestedForm controller connected")
    // Ukrywamy wszystkie istniejące pola oznaczone do usunięcia
    this.fieldsTargets.forEach(field => {
      const destroyCheckbox = field.querySelector("input[name*=\"_destroy\"]")
      if (destroyCheckbox && destroyCheckbox.checked) {
        field.style.display = "none"
      }
    })
  }

  // Dodaje nowe pole na podstawie template
  addField(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML
    // Generujemy unikalny timestamp dla nowych rekordów (Rails nested attributes wymaga unikalnego ID)
    const uniqueId = new Date().getTime()
    // Zamieniamy NEW_RECORD na timestamp
    const newContent = content.replace(/NEW_RECORD/g, uniqueId)

    // Dodajemy nowe pole do kontenera
    this.containerTarget.insertAdjacentHTML("beforeend", newContent)

    console.log("Field added")
  }

  // Usuwa pole (dla istniejących rekordów oznacza checkbox _destroy, dla nowych usuwa z DOM)
  removeField(event) {
    event.preventDefault()

    const field = event.target.closest("[data-nested-form-target='fields']")
    if (!field) return

    // Sprawdzamy czy to istniejący rekord (ma input z id)
    const idInput = field.querySelector("input[name*=\"[id]\"]")
    const destroyInput = field.querySelector("input[name*=\"_destroy\"]")

    if (idInput && idInput.value) {
      // Istniejący rekord - oznaczamy do usunięcia
      if (destroyInput) {
        destroyInput.value = "1"
        destroyInput.checked = true
      }
      // Ukrywamy pole wizualnie
      field.style.display = "none"
    } else {
      // Nowy rekord - po prostu usuwamy z DOM
      field.remove()
    }

    console.log("Field removed")
  }
}
